import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import BetslipWebBridgeEffects from './betslip-web-bridge.effects';
import { BetslipWebBridgeService } from './betslip-web-bridge.service';

@NgModule({
    imports: [EffectsModule.forFeature([BetslipWebBridgeEffects])],
    providers: [BetslipWebBridgeService],
})
export default class BetslipWebBridgeModule {}
